import { useSiteSettingsPublished } from './useSiteSettingsPublished';

export const HOLDING_PAGE_SETTINGS_KEY = 'holding_page';

export interface HoldingPageSettings {
  enabled: boolean;
  eyebrow: string;
  title: string;
  body: string;
  instagramUrl: string;
  facebookUrl: string;
  emailAddress: string;
  footerText: string;
}

export const DEFAULT_HOLDING_PAGE_SETTINGS: HoldingPageSettings = {
  enabled: true,
  eyebrow: 'Coming Soon',
  title: 'Eco3Dcor',
  body:
    'The new site is being prepared. Fresh product pages, event dates, and the next collection will be published here shortly.',
  instagramUrl: 'https://www.instagram.com/eco3dcor',
  facebookUrl: 'https://www.facebook.com/Eco3Dcor/',
  emailAddress: 'info@eco3dcor.com',
  footerText: '',
};

function normalizeString(value: unknown, fallback: string) {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : fallback;
}

export function normalizeHoldingPageSettings(value: unknown): HoldingPageSettings {
  const raw = value && typeof value === 'object' ? (value as Record<string, unknown>) : {};

  return {
    enabled:
      typeof raw.enabled === 'boolean' ? raw.enabled : DEFAULT_HOLDING_PAGE_SETTINGS.enabled,
    eyebrow: normalizeString(raw.eyebrow, DEFAULT_HOLDING_PAGE_SETTINGS.eyebrow),
    title: normalizeString(raw.title, DEFAULT_HOLDING_PAGE_SETTINGS.title),
    body: normalizeString(raw.body, DEFAULT_HOLDING_PAGE_SETTINGS.body),
    instagramUrl: normalizeString(raw.instagramUrl, DEFAULT_HOLDING_PAGE_SETTINGS.instagramUrl),
    facebookUrl: normalizeString(raw.facebookUrl, DEFAULT_HOLDING_PAGE_SETTINGS.facebookUrl),
    emailAddress: normalizeString(raw.emailAddress, DEFAULT_HOLDING_PAGE_SETTINGS.emailAddress),
    footerText: normalizeString(raw.footerText, DEFAULT_HOLDING_PAGE_SETTINGS.footerText),
  };
}

export function useHoldingPageSettings(mode: 'published' | 'draft' = 'published') {
  return useSiteSettingsPublished(HOLDING_PAGE_SETTINGS_KEY, {
    defaultValue: DEFAULT_HOLDING_PAGE_SETTINGS,
    normalize: normalizeHoldingPageSettings,
    mode,
  });
}
